<template>
  <div class="result_container">
    <div class="hd">
      <span class="header_title">领取优惠券</span>
    </div>
    <div class="operation_box">

      <img
        class="bd"
        src="/static/img/operationsuccess.png"
      />
      <span class="main" :lines="1">{{result}}</span>
      <span class="submain" :lines="1">{{text}}</span>
      <div class="return-button" @click="goHome"><span class="tag">返回主页</span></div>
      <a :href="lotteryUrl" v-if="ifShowLottery && lotteryUrl">
        <img src="/emktResources/resocurces/img/promotion/首单抽奖.png" class="lottery-image">
      </a>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    mounted () {
      if (this.ifShowLottery) {
        $.showPreloader('正在查询活动信息')
        this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
          $.hidePreloader()
          if (res.body.result && res.body.result.length > 0) {
            let lotteryInfo = res.body.result[0]
            this.lotteryUrl = lotteryInfo.url
          }
        })
      }
    },
    data () {
      return {
        constants: {},
        result: this.$route.query.result,
        text: this.$route.query.text,
        ifShowLottery: this.$route.query.showLottery,
        lotteryUrl: ''
      }
    },
    methods: {
      goHome () {
        this.$router.replace({name: 'home'})
      }
    }
  }
</script>
<style scoped>
  .result_container {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100%;
  }
  .operation_box {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #efeef3;
    width: 100vw;
    height: 100vh;
    top: 56px;
  }
  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    width: 100vw;
    height: 56px;
    z-index: 10;
    justify-content: center;
    background-color: #013C8E;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
  }

  .bd {
    position: relative;
    margin-top: 15vh;
    width: 60px;
  }

  .main {
    position: relative;
    opacity: 1;
    margin-top: 20px;
    max-width: 320px;
    white-space: nowrap;
    color: #424242;
    font-size: 20px;
    font-weight: 400;
  }

  .submain {
    position: relative;
    opacity: 1;
    margin-top: 10px;
    max-width: 320px;
    text-align: center;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .return-button {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 51px;
    border-radius: 5.87vw;
    background-color: #013c8e;
    width: 320px;
    height: 44px;
  }

  .tag {
    opacity: 1;
    max-width: 83.47vw;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

   .lottery-image {
     width: 90%;
     margin: 20px auto;
     display: block;
   }

</style>




// WEBPACK FOOTER //
// OperationResult.vue?3422c1bf